export default __webpack_public_path__ + "static/media/suspended_icon.b9663954.svg";